import { captureException, captureMessage } from '@sentry/react'
import { createFileRoute, notFound, redirect } from '@tanstack/react-router'

import { regionPromotionsQuery } from '@/state/promotions/promotions'
import { regionQuery } from '@/state/regions/region'

export const Route = createFileRoute('/promotions/$initiativeId/$regionId')({
  beforeLoad: ({ context, params }) => {
    if (context.auth.sys_admin || context.auth.regionId === params.regionId) {
      return
    }
    if (!context.auth.regionId) {
      throw notFound()
    }
    throw redirect({
      to: '/promotions/$initiativeId/$regionId',
      params: { initiativeId: params.initiativeId, regionId: context.auth.regionId },
      replace: true,
    })
  },
  loader: async ({ context, params }) => {
    const [{ exists: regionExists }] = await Promise.all([
      context.queryClient.fetchQuery(regionQuery(params.regionId)),
      context.queryClient.prefetchQuery(regionPromotionsQuery(params)),
    ])
    if (!regionExists) {
      captureMessage(`Region ${params.regionId} not found`, { extra: { params } })
      throw notFound()
    }
  },
  onCatch: (error) => {
    captureException(error, { tags: { route: Route.fullPath } })
  },
})
